module.exports = __webpack_public_path__ + "img/pic_Left Img.32d54bf9.png";